<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">{{ $translate('patients') | capitalize }}</h1>

      <!--<b-button @click="saveAll()">Resave</b-button>-->

      <table-actions
        :can-create="permissions.canCreate"
        :can-hide="permissions.canHide"
        :can-delete="permissions.canDelete"
        :can-export="permissions.canExport"
        :multiple-selection-icon="multipleSelectionIcon"
        :form-link="{
          name: 'newPatient',
        }"
        :checked-rows.sync="tableOptions.checkedRows"
        :disabled.sync="tableOptions.loading"
        @viewhiddenchange="switchViewHidden"
        @search="searchData"
        @getTable="getTable"
        @changesearchQuery="changesearchQuery"
        @hideItems="multipleHiding('patients')"
        @deleteItems="deleteItems"
      />
      <div class="level second-level">
        <div class="level-left">
          <div class="level-item">
            <p class="is-size-5 has-text-primary">
              {{ $translate('filter') | capitalize }}
            </p>
          </div>
          <div class="level-item">
            <filter-select v-if="userInfo.type == 'C'" v-model="shopsFilterInfo" @change="searchData()" />
          </div>
          <div class="level-item">
            <filter-select v-if="userInfo.type == 'C'" v-model="technicianFilterInfo" @change="searchData()" />
          </div>
          <div class="level-item">
            <filter-select v-model="typesFilterInfo" @change="searchData()" />
          </div>
        </div>
      </div>
      <b-table
        :sticky-header="true"
        :data="tableData"
        :narrowed="true"
        :checked-rows.sync="tableOptions.checkedRows"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        :backend-sorting="true"
        checkable
        detailed
        hoverable
        :row-class="(row, index) => !row.isActive && 'hiding-row'"
        @sort="sortPressed"
        @check="multipleSelectionIconManage"
      >
        <template slot-scope="props">
          <b-table-column field="mercurio_id" :label="$translate('id_mercury') | capitalize" sortable>
            {{ props.row.mercurio_id }}
          </b-table-column>
          <b-table-column
            field="shopId"
            :label="$translate('shops') | capitalize"
            :sortable="$route.params.shopId == undefined"
          >
            <a
              v-if="props.row.shop != undefined"
              @click="
                $router.push({
                  name: 'shops',
                  params: { shopId: props.row.shopId },
                })
              "
              >{{ props.row.shop.name }}</a
            >
          </b-table-column>
          <b-table-column field="technician" :label="$translate('technician') | capitalize" sortable>
            {{ props.row.technician }}
          </b-table-column>
          <b-table-column field="name" :label="$translate('name') | capitalize" :sortable="allShops && allCompanies">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column
            field="surname"
            :label="$translate('surname') | capitalize"
            :sortable="allShops && allCompanies"
          >
            {{ props.row.surname }}
          </b-table-column>
          <b-table-column field="alias" :label="$translate('alias') | capitalize" :sortable="allShops && allCompanies">
            {{ props.row.alias }}
          </b-table-column>

          <b-table-column field="birthdate" :label="$translate('birthdate') | capitalize">
            {{ props.row.birthdate ? new Date(props.row.birthdate.seconds * 1000).toLocaleDateString() : '' }}
          </b-table-column>
          <b-table-column field="gender" :label="$translate('sex') | capitalize">
            {{ $translate(props.row.gender) | capitalize }}
          </b-table-column>
          <b-table-column field="active" :label="$translate('active') | capitalize">
            <b-icon :icon="props.row.isActive ? 'eye' : 'eye-off'" />
          </b-table-column>
          <b-table-column :label="$translate('action') | capitalize">
            <div class="is-flex is-align-content-center">
              <a
                v-if="permissions.canEdit"
                @click="
                  $router.push({
                    name: 'editPatient',
                    params: { id: props.row.id },
                  })
                "
              >
                <b-icon icon="pencil-outline" />
              </a>
              <a
                @click="
                  $router.push({
                    name: 'orders',
                    params: { patientId: props.row.id },
                  })
                "
              >
                <b-icon icon="format-list-checkbox" />
              </a>

              <patient-create-order-action
                v-on:openModal="openNewOrderModal"
                v-on:navToModule="navToModule"
                :hidden="canCreateOrder()"
                :row="props.row"
              />
            </div>
            <!--<a
              @click="
                $router.push({
                  name: 'Calendar',
                  params: { id: props.row.id },
                })
              "
            >
              <b-icon icon="calendar-month-outline" />
            </a>-->
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ $translate('mail') | capitalize }}:</strong>
                  {{ props.row.email }}
                </p>
                <p>
                  <strong>{{ $translate('address') | capitalize }}:</strong>
                  {{ printAddress(props.row.address) }}
                </p>
                <p>
                  <strong>{{ $translate('note') | capitalize }}:</strong>
                  {{ props.row.notes }}
                </p>
              </div>
            </div>
          </article>
        </template>
        <template v-if="!disableRequestMore" slot="footer">
          <b-button expanded @click="appendData()">
            <b-icon icon="arrow-down-thick" />
          </b-button>
        </template>
        <template slot="empty">
          <section v-if="!tableOptions.loading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </div>

    <b-modal :active="isModalActive" v-model="isModalActive" :width="640" scroll="keep">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('select your order module') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field v-if="patientInfo && patientInfo.moduleTailored">
            <b-radio v-model="orderType" native-value="tailored">
              {{ $translate('orderTailored') }}
            </b-radio>
          </b-field>
          <b-field v-if="patientInfo && patientInfo.moduleFits">
            <b-radio v-model="orderType" native-value="fits">
              {{ $translate('orderFits') }}
            </b-radio>
          </b-field>
          <b-field v-if="patientInfo && patientInfo.moduleModular">
            <b-radio v-model="orderType" native-value="modular">
              {{ $translate('orderModular') }}
            </b-radio>
          </b-field>
          <b-field v-if="patientInfo && patientInfo.moduleInsole">
            <b-radio v-model="orderType" native-value="insole">
              {{ $translate('orderInsole') }}
            </b-radio>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button is-primary" type="button" @click="navToModule(patientInfo, orderType)">
            {{ $translate('Continue') | capitalize }}
          </b-button>
          <button class="button" type="button" @click="isModalActive = false">
            {{ $translate('close') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import firebase from 'firebase'
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import filterSelect from '@/components/FilterSelect'
import tableActions from '@/components/TableActions'
import PatientCreateOrderAction from './PatientCreateOrderAction'
//import keyWordGenerator from "@/helpers/mixins/keyWordGenerator.js";

export default {
  name: 'patients',
  mixins: [mainMixin, permissionMixin /*, keyWordGenerator*/],
  components: {
    'filter-select': filterSelect,
    'table-actions': tableActions,
    PatientCreateOrderAction,
  },
  data() {
    return {
      field: null,
      order: null,
      queryString: '',
      shopindex: 0,
      tecindex: 1,
      shops: [],
      AllshopsId: [],
      AlltecsId: [],
      mainQuery: this.$db.collection('patients').where('isActive', '==', true),
      query: "this.$db.collection('patients').where('isActive', '==', true)",
      lastRequested: null,
      disableRequestMore: true,
      limit: 20,
      shopFilter: '',
      patientInfo: null,
      orderType: 'tailored',

      shopsFilterInfo: {
        label: 'shop',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      typesFilterInfo: {
        label: 'sex',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      technicianFilterInfo: {
        label: 'technician',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      isModalActive: false,
    }
  },
  mounted() {
    if (!this.userInfo.type) this.$router.push('/forbidden')
    //let permissionDenied = true
    switch (this.userInfo.type) {
      case 'A':
        //permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        this.permissions.canExport = true
        break
      case 'I':
        this.permissions.canExport = true
        if (this.userInfo.level === 'S') {
          this.permissions.canHide = true
          this.permissions.canEdit = true
          this.permissions.canCreate = true
          this.permissions.canDelete = true
        }
        break
      case 'C':
        //permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        this.permissions.canExport = this.userInfo.level === '1' ? false : true
        break
    }
    //if (permissionDenied) this.$router.push('/forbidden')
    if (this.$route.params.shopId) {
      this.setFilterValues(this.$store.state.filters.patients.gender, this.$route.params.shopId)
    }
    this.loadData()
  },
  methods: {
    /*async saveAll() {
      await this.$db
        .collection("patients")
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let newCom = doc.data();
            newCom.id = doc.id;
            newCom.orders = [];
            this.$db
              .collection("patients")
              .doc(doc.id)
              .update(newCom)
              .then(() => {
                console.log("aggiornato: " + doc.id);
              });
          });
        });
    },*/

    /*resaveAll() {
      this.$db
        .collection("patients")
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let patient = doc.data();
            patient.id = doc.id;
            patient.searchArray = this.generateKeyWord([
              patient.name,
              patient.surname,
              patient.technician,
              patient.alias,
              patient.mercurio_id
            ]);

            this.$db
              .collection("patients")
              .doc(patient.id)
              .update(patient);
          });
        });
    },*/

    sortPressed(field, order) {
      switch (field) {
        case 'shopId':
          this.AllshopsId.reverse()
          break
        case 'technician':
          this.AlltecsId.reverse()
          break
      }

      this.field = field
      this.order = order
      this.searchData()
    },

    changesearchQuery(querystring = '') {
      this.queryString = querystring
    },
    loadFilterValues() {
      this.typesFilterInfo.filterValue = this.$store.state.filters.patients.gender
      this.shopFilter = this.$store.state.filters.patients.shop
    },
    setFilterValues(gender, shop) {
      this.$store.commit('setFiltersPatients', {
        gender: gender,
        shop: shop,
      })
    },
    async loadData() {
      this.tableOptions.loading = true
      await this.createFilters()
      this.tableData = []

      //set latest filter used
      this.loadFilterValues()

      //if (this.$route.params.shopId) {
      if (this.shopFilter) {
        this.mainQuery = this.$db
          .collection('patients')
          //.where("shopId", "==", this.$route.params.shopId);
          .where('shopId', '==', this.shopFilter)
        //console.log(`this.$db.collection("patients").where("shopId", "==", ${this.$route.params.shopId}`)
      } else if (this.$route.params.patientId) {
        this.mainQuery = this.$db
          .collection('patients')
          .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.patientId)
        //console.log(`this.$db.collection("patients").where(${firebase.firestore.FieldPath.documentId()}, "==", ${this.$route.params.patientId}`)
      }
      if (this.typesFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where(
          'gender',
          '==',
          this.$options.filters.capitalize(this.typesFilterInfo.filterValue)
        )
      }
      this.appendData()
    },

    searchData() {
      this.tableData = []
      this.tableOptions.loading = true

      //update filters
      this.setFilterValues(this.typesFilterInfo.filterValue, this.$store.state.filters.patients.shop)

      this.mainQuery = this.$db.collection('patients')
      //if (this.$route.params.shopId) {
      if (this.shopFilter) {
        this.mainQuery = this.$db
          .collection('patients')
          //.where("shopId", "==", this.$route.params.shopId);
          .where('shopId', '==', this.shopFilter)
      } else if (this.$route.params.patientId) {
        this.mainQuery = this.$db
          .collection('patients')
          .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.patientId)
      }

      this.mainQuery = this.mainQuery.where('searchArray', 'array-contains', this.queryString.toLowerCase())
      if (this.technicianFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('technician', '==', this.technicianFilterInfo.filterValue)
      }
      if (this.typesFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where(
          'gender',
          '==',
          this.$options.filters.capitalize(this.typesFilterInfo.filterValue)
        )
      }
      if (this.shopsFilterInfo.filterValue != '*') {
        let tempshopsearch = this.shops.find(temp => temp.name == this.shopsFilterInfo.filterValue)
        if (tempshopsearch != undefined) {
          this.mainQuery = this.mainQuery.where('shopId', '==', tempshopsearch.id)
        }
      }
      if (!this.showHidden) {
        this.mainQuery = this.mainQuery.where('isActive', '==', true)
      }

      this.lastRequested = null
      this.shopindex = 0
      this.tecindex = 0
      this.appendData()
    },

    async appendData(newlimit = this.limit) {
      this.tableOptions.loading = true
      let thisQuery = this.mainQuery

      if (this.field == 'technician') {
        thisQuery = thisQuery.where('technician', '==', this.AlltecsId[this.tecindex])
        //console.log(`.where("techincian", "==", ${this.AlltecsId[this.tecindex]}`)
      } else {
        if (this.allShops && this.allCompanies) {
          if (this.field != null) {
            thisQuery = thisQuery.orderBy(this.field, this.order)
            //console.log(`.orderBy(${this.field}, ${this.order})`)
          }
        }
      }

      if (!this.allCompanies || !this.allShops || this.field == 'technician') {
        thisQuery = thisQuery.where('shopId', '==', this.AllshopsId[this.shopindex])
        //console.log(`.where("shopId", "==", ${this.AllshopsId[this.shopindex]})`)
      }

      if (this.lastRequested != null) {
        thisQuery = thisQuery.startAt(this.lastRequested)
        //console.log(`.startAt(${this.lastRequested})`)
      }
      await thisQuery
        .limit(newlimit + 1)
        .get()
        .then(docs => {
          if (docs.size > newlimit) {
            this.disableRequestMore = false
          } else {
            this.disableRequestMore = true
          }
          let i = 0
          docs.forEach(doc => {
            let newPatient = doc.data()
            newPatient.id = doc.id
            let tempshop = this.shops.find(temp => temp.id == newPatient.shopId)
            if (tempshop != undefined) {
              newPatient.shop = tempshop
            }
            i++
            if (i <= this.limit) {
              this.tableData.push(newPatient)
            }
            this.lastRequested = doc
          })
          if (
            this.disableRequestMore &&
            this.AllshopsId.length > this.shopindex + 1 &&
            (!this.allCompanies || !this.allShops || this.field == 'technician')
          ) {
            this.shopindex += 1
            this.lastRequested = null
            this.appendData(newlimit - docs.size)
          } else {
            if (this.disableRequestMore && this.field == 'technician' && this.AlltecsId.length > this.tecindex + 1) {
              this.shopindex = 0
              this.tecindex += 1
              this.lastRequested = null
              this.appendData(newlimit - docs.size)
            } else {
              this.tableOptions.loading = false
            }
          }
        })
    },

    async createFilters() {
      this.shopsFilterInfo.options = [{ name: '*' }]
      this.typesFilterInfo.options = [{ name: '*' }]
      this.technicianFilterInfo.options = [{ name: '*' }]

      if (!this.allCompanies) {
        if (this.allShops) {
          for (let companiesindex = 0; companiesindex < this.companiesId.length; companiesindex += 10) {
            //console.log("banana");
            await this.$db
              .collection('shops')
              .where('companyId', 'in', this.companiesId.slice(companiesindex, companiesindex + 10))
              .get()
              .then(docs => {
                docs.forEach(doc => {
                  let sho = doc.data()
                  sho.id = doc.id
                  this.shopsFilterInfo.options.push({
                    name: sho.name,
                  })
                  this.shops.push(sho)
                  this.AllshopsId.push(sho.id)
                })
              })
          }
        } else {
          for (let tempshopindex = 0; tempshopindex < this.shopsId.length; tempshopindex += 10) {
            await this.$db
              .collection('shops')
              .where(
                firebase.firestore.FieldPath.documentId(),
                'in',
                this.shopsId.slice(tempshopindex, tempshopindex + 10)
              )
              .get()
              .then(docs => {
                docs.forEach(doc => {
                  let sho = doc.data()
                  sho.id = doc.id
                  this.shopsFilterInfo.options.push({
                    name: sho.name,
                  })
                  this.shops.push(sho)
                  this.AllshopsId.push(sho.id)
                })
              })
          }
        }
      } else {
        await this.$db
          .collection('shops')
          .get()
          .then(docs => {
            docs.forEach(doc => {
              let sho = doc.data()
              sho.id = doc.id
              this.shopsFilterInfo.options.push({
                name: sho.name,
              })
              this.shops.push(sho)
              this.AllshopsId.push(sho.id)
            })
          })
      }

      for (let indexsex in this.$availableSexType) {
        this.typesFilterInfo.options.push({
          name: this.$availableSexType[indexsex],
        })
      }

      if (this.allCompanies) {
        await this.$db
          .collection('usersInfo')
          .where('type', '==', 'C')
          .get()
          .then(snapshot => {
            snapshot.forEach(user => {
              this.technicianFilterInfo.options.push({
                name: user.data().username,
              })
              this.AlltecsId.push(user.data().username)
            })
          })
      } else if (this.userInfo.type == 'I') {
        for (let i = 0; i < this.companiesId.length; i += 10) {
          await this.$db
            .collection('usersInfo')
            .where('type', '==', 'C')
            .where('companyId', 'in', this.companiesId.slice(i, i + 10))
            .get()
            .then(snapshot => {
              snapshot.forEach(user => {
                this.technicianFilterInfo.options.push({
                  name: user.data().username,
                })
                this.AlltecsId.push(user.data().username)
              })
            })
        }
      } else {
        this.$db
          .collection('usersInfo')
          .where('type', '==', 'C')
          .where('companyId', '==', this.companiesId[0])
          .get()
          .then(snapshot => {
            snapshot.forEach(user => {
              if (user.data().shopsId.some(element => this.AllshopsId.concat(['*']).includes(element))) {
                this.technicianFilterInfo.options.push({
                  name: user.data().username,
                })
                this.AlltecsId.push(user.data().username)
              }
            })
          })
      }
    },

    canCreateOrder() {
      if (this.userInfo.type === 'I' && this.userInfo.level === '1') return true
      return false
    },

    async deleteItems() {
      if (this.userInfo.type === 'C' && this.userInfo.level === '1') {
        this.tableOptions.loading = true
        let arraytoremove = []
        for (let row in this.tableOptions.checkedRows) {
          await this.$db
            .collection('orders')
            .where('patientId', '==', this.tableOptions.checkedRows[row].id)
            .get()
            .then(docs => {
              if (docs.size > 0) {
                arraytoremove.push(this.tableOptions.checkedRows[row])
              }
            })
        }

        for (let elementtoremove in arraytoremove) {
          let index = this.tableOptions.checkedRows.indexOf(arraytoremove[elementtoremove])
          if (index > -1) {
            this.tableOptions.checkedRows.splice(index, 1)
          }
        }
        this.tableOptions.loading = false

        if (this.tableOptions.checkedRows.length != 0) {
          this.multipleDelete('patients')
        }
      } else {
        this.multipleDelete('patients')
      }
    },

    getTable() {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent +=
        this.$translate('id_mercury') +
        ';' +
        this.$translate('shops') +
        ';' +
        this.$translate('technician') +
        ';' +
        this.$translate('name') +
        ';' +
        this.$translate('surname') +
        ';' +
        this.$translate('alias') +
        ';' +
        this.$translate('birthdate') +
        ';' +
        this.$translate('sex') +
        ';' +
        this.$translate('active') +
        ';' +
        this.$translate('address') +
        ';' +
        this.$translate('email') +
        ';' +
        this.$translate('note') +
        '\n'

      this.tableOptions.checkedRows.forEach(row => {
        csvContent += `${row.mercurio_id ? row.mercurio_id : ''}; ${row.shop.name}; ${row.technician}; ${row.name}; ${
          row.surname
        }; ${row.alias};${
          row.birthdate ? new Date(row.birthdate.seconds * 1000).toLocaleDateString() : ''
        };${this.$translate(row.gender)}; ${row.isActive ? 'y' : 'n'}; ${this.printAddress(row.address)}; ${
          row.email
        }; ${row.notes}\n`
      })

      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        this.$options.filters.capitalize(this.$translate('patients')) +
          `${this.$store.getters.user.userInfo.name}${
            this.$store.getters.user.userInfo.surname
          }${new Date().toLocaleDateString()}H${new Date().toLocaleTimeString()}.csv`
      )
      document.body.appendChild(link)
      link.click()
    },

    openNewOrderModal(row) {
      this.isModalActive = true
      this.patientInfo = row
    },

    navToModule(row, module) {
      this.$router.push({
        name: 'newOrder',
        params: {
          patientId: row.id,
          module,
          view: true,
          startingorderType: 'firstOrder',
        },
      })
    },
  },
}
</script>
<style scoped>
.container >>> .table-footer td {
  color: #bdbdbd;
}

@media only screen and (min-width: 1280px) {
  .container >>> .b-table .table th {
    font-weight: 600;
    position: sticky;
    top: 120px;
    background: white;
    z-index: 8;
  }

  .first-level {
    height: 60px;
    background: white;
    top: 0px;
    position: sticky;
    z-index: 9;
    margin-top: 0;
    margin-bottom: 0;
  }

  .second-level {
    height: 60px;
    background: white;
    top: 60px;
    position: sticky;
    z-index: 8;
    margin-top: 0;
    margin-bottom: 0;
  }

  .container >>> .dropdown-menu {
    z-index: 5;
  }
}
</style>
